import EvalModelsPage from "@Evaluation/EvaluationModels/Pages/EvalModelsPage.vue";
import VotesGeneratorPage from "@Evaluation/EvaluationModels/Pages/VotesGeneratorPage.vue";
import PanelistLandingPage from "@Evaluation/EvaluationModels/Pages/PanelistLandingPage.vue";


export const routes = [
    {
        path: "/pp/goals/:workspaceId/:projectId",
        component: EvalModelsPage,
    },
    {
        path: "/votes-generator",
        component: VotesGeneratorPage,
    },
    {
        path: "/survey/:surveyAccessToken/:projectUserAccessToken",
        component: PanelistLandingPage,
    },
    {
        path: "/estimate/:surveyAccessToken/:projectUserAccessToken",
        component: PanelistLandingPage,
    },
]
